import React from 'react';
import { motion } from 'framer-motion';
import { BadgeDollarSignIcon, HeadsetIcon, ZapIcon, LifeBuoyIcon } from 'lucide-react';
const benefits = [{
  title: 'Average 30% Savings',
  description: 'Our clients save an average of 30% on their telecom expenses. We find overcharges, negotiate better rates, and eliminate waste across every bill.',
  icon: BadgeDollarSignIcon
}, {
  title: 'Free Bill Audit',
  description: "We analyze your current telecom bills at no cost. If we can't find savings, you pay nothing. There's zero risk to getting started.",
  icon: HeadsetIcon
}, {
  title: 'Fast Implementation',
  description: 'See savings within your first billing cycle. Our streamlined process means no disruption to your operations while we optimize your services.',
  icon: ZapIcon
}, {
  title: 'Ongoing Monitoring',
  description: 'Telecom costs creep up over time. We continuously monitor your accounts and proactively flag rate increases, contract renewals, and new savings opportunities.',
  icon: LifeBuoyIcon
}];
export function WhyChooseUs() {
  return <section className="py-24 bg-white" data-id="element-464">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-465">
        <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-466">
          <div className="w-full lg:w-1/3" data-id="element-467">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-468">
              Why Businesses Trust Us to Cut Costs
            </h2>
            <p className="text-lg text-slate-600 mb-8" data-id="element-469">
              We work for you, not the carriers. Our only goal is reducing your
              telecom expenses while maintaining or improving your service
              quality.
            </p>
            <a href="#quote" className="inline-flex items-center justify-center bg-primary hover:bg-primary-dark text-white px-6 py-3 rounded-full font-medium transition-colors" data-id="element-470">
              Get Your Free Analysis
            </a>
          </div>

          <div className="w-full lg:w-2/3" data-id="element-471">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8" data-id="element-472">
              {benefits.map((benefit, index) => {
              const Icon = benefit.icon;
              return <motion.div key={index} initial={{
                opacity: 0,
                y: 20
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.5,
                delay: index * 0.1
              }} className="flex flex-col" data-id="element-473">
                    <div className="w-14 h-14 bg-accent/10 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform" data-id="element-474">
                      <Icon className="w-7 h-7 text-accent" data-id="element-475" />
                    </div>
                    <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-476">
                      {benefit.title}
                    </h3>
                    <p className="text-slate-600 leading-relaxed" data-id="element-477">
                      {benefit.description}
                    </p>
                  </motion.div>;
            })}
            </div>
          </div>
        </div>
      </div>
    </section>;
}